// extracted by mini-css-extract-plugin
var _1 = "UserAddStep_text__12EnT";
export { _1 as "text" }
